import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export function getEnumLists() {
  return axiosInterceptors
    .get(ENV.metaDataEnumsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}



export async function  getAllEnumLists() {

return axiosInterceptors
.get(ENV.jobMetaDataEnumsUrl)
.then((responce)=>{
  return responce;
}
).catch((error)=>{
  return error;
})
  
}